import { useQuery } from '@tanstack/react-query';

import { isSameDay, isWeekend, parseISO } from 'date-fns';

import {
  FetchPayCyclesRequest,
  FetchPayCyclesResponse,
  holidaysService,
  PayCalendarLocation,
  payCyclesService,
} from '@aslanpay/portal-common-lib';

import { PayCyclePage } from 'app/components/UI/Table/Table.types';

const useFetchPayCycles = (
  {
    payCalendarId,
    ids,
    status,
    startDateBefore,
    startDateAfter,
    sortBy,
    sort,
    page,
    size,
  }: FetchPayCyclesRequest,
  location: PayCalendarLocation
) => {
  return useQuery<FetchPayCyclesResponse, Error, PayCyclePage>(
    [
      'fetchPayCycles',
      payCalendarId,
      ids,
      status,
      startDateBefore,
      startDateAfter,
      sortBy,
      sort,
      page,
      size,
    ],
    async () => {
      const payCycles = await payCyclesService.fetchPayCycles({
        payCalendarId,
        ids,
        status,
        startDateBefore,
        startDateAfter,
        sortBy,
        sort,
        page,
        size,
      });

      const holidays = await holidaysService.fetchHolidays({ location: [location] });

      const payCyclesList = payCycles.list.map((payCycle) => {
        const isCutoffHoliday = holidays.some((holiday) =>
          isSameDay(parseISO(holiday.date), parseISO(payCycle.cutoffDate))
        );

        const isCutoffWeekend = isWeekend(parseISO(payCycle.cutoffDate));

        const isPaydayHoliday = holidays.some((holiday) =>
          isSameDay(parseISO(holiday.date), parseISO(payCycle.payday))
        );

        const isPaydayWeekend = isWeekend(parseISO(payCycle.payday));

        return { ...payCycle, isCutoffHoliday, isCutoffWeekend, isPaydayHoliday, isPaydayWeekend };
      });

      return { ...payCycles, list: payCyclesList };
    }
  );
};

export default useFetchPayCycles;
